/* unplugin-vue-components disabled */import { render } from "./alert.vue?vue&type=template&id=62d00da1&scoped=true"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"

import "./alert.vue?vue&type=style&index=0&id=62d00da1&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d00da1"]])

export default __exports__